import React from 'react';
import { connect } from 'react-redux';

import Header from '../../containers/Header/Header';
import Preface from '../../containers/Preface/Preface';
import Primary from '../../containers/Primary/Primary';
import Aside from '../../containers/Aside/Aside';
import Footer from '../../containers/Footer/Footer';

const layout = props => {
  let prefaceBlock = <Preface />
  if (!props.isHome) {
    prefaceBlock = ''
  }

  return (
    <>
      <Header />
      <div className="py-10 bg-green-light">
        {prefaceBlock}
        <main className="grid grid-cols-6 mx-6 mt-5">
          <Primary>
            {props.children}
          </Primary>
          <Aside />
        </main>
        <Footer />
      </div>
    </>
  )
}

const mapsStateToProps = state => {
  return {
    isHome: state.isHome,
  }
}

export default connect(mapsStateToProps)(layout);
